import { decryptData } from "./crypto_utils";

export default function getAuthUserStorage() {
  const storedData =
    sessionStorage.getItem("authUser") || localStorage.getItem("authUser");

  if (!storedData) return null;

  return decryptData(storedData);
}
